export default __webpack_public_path__ + "static/media/Leardini.12b1fd66.png";